module.exports = __webpack_public_path__ + "img/master-component.14cc33ab.svg";